import React, { Component } from 'react'
import styled from 'styled-components'
import NotesUtil from '../../helpers/NotesUtil'

const Container = styled.div`
  margin-bottom: 25px;
`
const Header = styled.div`
  margin-bottom: 10px;
`
const Title = styled.div`
  height: 19px;
  color: #6A6A6A;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  line-height: 19px;
  text-transform: capitalize;
`
const DescriptionContainer = styled.div`
  margin-left:50px;
`
const Description = styled.span`
  display: list-item;
  margin-bottom: 10px;
  color: #56565A;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 19px;
  list-decoration-type: none;
  a {
    color: #48A3D1;
  }
`

export default class HelpfulHint extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ...props
    }
  }
  anchorLinkListener = e => {
    const { target: { tagName } } = e
    if (tagName === 'A') {
      NotesUtil.gotoTab(e)
    }
  }
  render() {
    const { title, helpfulHints } = this.state.hint
    return (
      <Container>
        <Header>
          <Title>{title}</Title>
        </Header>
        {helpfulHints.length > 0 && (
          <DescriptionContainer>
            {helpfulHints.map(({ rid, description }) => (
              <Description 
                key={rid}
                onClick={this.anchorLinkListener}
                dangerouslySetInnerHTML={{ __html: description }}
              />
              ))
            }
          </DescriptionContainer>
        )}
      </Container>

    )
  }
}
